import React, { useRef } from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "@mui/material";

interface CheckboxCmpPropsInterface {
  color?: string;
  title: any;
  font?: string;
  onBtnClick: any;
  checkedColor?: string;
  checkboxRef?: any;
}

export default function CheckboxCmp({
  color,
  title,
  font,
  onBtnClick,
  checkedColor,
  checkboxRef,
}: CheckboxCmpPropsInterface) {
  const title1 = <b>{title}</b>;

  return (
    <FormControlLabel
      ref={checkboxRef}
      style={{
        color: `${color}`,
        fontWeight: "bold",
        marginRight: 0,
        paddingRight: 0,
        fontSize: "14px !important",
      }}
      className={` ${font} textFont14`}
      value="end"
      control={<Checkbox onClick={onBtnClick} />}
      label={title1}
      labelPlacement="end"
      sx={{
        "& .MuiSvgIcon-root": { fontSize: 24 },
        "& .Mui-checked": { color: checkedColor },
      }}
    />
  );
}
